(()=>{
function bindNavigation(root){
 if(root.dataset.navigationReady)return;root.dataset.navigationReady='true';
 const menu=root.querySelector('.cvc-menu-button'),nav=root.querySelector('.cvc-nav');
 if(!menu||!nav)return;
 const dropdown=nav.querySelector('.cvc-nav-dropdown');
 function closeDropdown(){if(dropdown)dropdown.open=false;}
 function setMenu(open){nav.classList.toggle('is-open',open);menu.setAttribute('aria-expanded',String(open));menu.setAttribute('aria-label',open?'Close navigation':'Open navigation');if(!open)closeDropdown();}
 menu.addEventListener('click',()=>setMenu(menu.getAttribute('aria-expanded')!=='true'));
 nav.addEventListener('click',e=>{if(e.target.closest('a'))setMenu(false);});
 document.addEventListener('keydown',e=>{if(e.key==='Escape'){setMenu(false);closeDropdown();}});
 document.addEventListener('click',e=>{if(dropdown&&!dropdown.contains(e.target))closeDropdown();if(nav.classList.contains('is-open')&&!nav.contains(e.target)&&!menu.contains(e.target))setMenu(false);});
 window.matchMedia('(min-width:1101px)').addEventListener('change',()=>setMenu(false));
 if(root.id==='cvc-site-header'){
   if(window.CVC_STATIC_PREVIEW)return;
   fetch('/cart.js').then(r=>r.ok?r.json():null).then(c=>{if(c)root.querySelector('.cvc-cart-count').textContent=`(${c.item_count})`;}).catch(()=>{});
 }
}
document.querySelectorAll('#cvc-store,#cvc-site-header').forEach(bindNavigation);
document.addEventListener('shopify:section:load',()=>document.querySelectorAll('#cvc-store,#cvc-site-header').forEach(bindNavigation));
})();
